import { config } from 'src/constants';
import { mockRequestHeaders } from 'src/mocks';

const getHttpConfig = (headers = {}, stringify = true) => {
  const headersData = ({
    'Content-Type': 'application/json',
    ...headers,
    ...(config.isDevEnv ? { ...mockRequestHeaders, cartId: 25008489 } : {}),
  });

  if (!stringify) {
    // used for file uploads. Browser auto-addes multipart/form-data with boundaries
    delete headersData['Content-Type'];
  }

  return { headers: headersData };
};

const getUpsertConfig = (method, payload, stringify = true, headers) => ({
  method,
  ...getHttpConfig(headers, stringify),
  body: stringify ? JSON.stringify(payload) : payload,
});

const http = {
  get: () => ({
    method: 'GET',
    ...getHttpConfig(),
  }),
  post: (payload, stringify, headers) => getUpsertConfig('POST', payload, stringify, headers),
  patch: (payload, stringify, headers) => getUpsertConfig('PATCH', payload, stringify, headers),
  put: (payload, stringify, headers) => getUpsertConfig('PUT', payload, stringify, headers),
  delete: (payload, stringify, headers) => ({
    method: 'DELETE',
    ...getHttpConfig(headers, stringify),
  }),
};

export default http;
